import { render, staticRenderFns } from "./ThreadPage.vue?vue&type=template&id=57b5ffda&scoped=true"
import script from "./ThreadPage.vue?vue&type=script&lang=js"
export * from "./ThreadPage.vue?vue&type=script&lang=js"
import style0 from "./ThreadPage.vue?vue&type=style&index=0&id=57b5ffda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5ffda",
  null
  
)

export default component.exports